import { BehaviorSubject } from 'rxjs';

import { getImageServer } from 'www/utils/get-image-server';
import { VideoSaver } from '../../save-video/save-video';
class PlaylistItem {
    constructor(config, SVP, sticky) {
        this.config = config;
        this.SVP = SVP;
        this.state = new BehaviorSubject({
            playing: false,
            watched: false
        })
        this._el = null;
        this.label = null;
        this.subscriptions = [];
        this.sticky = sticky;
    }
    destroySubscriptions() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        })
        this.subscriptions = [];
    }
    handleClick(e) {
        e.preventDefault();
        let { SVP, config } = this;
        let { video } = config;
        if (video.videoId != SVP.amp.media.metadata.videoId) {

            let mediaConfig = Object.assign({
                "ccFileRoot": "",
                "ccInfo": [],
                "controls": {
                    "enabled": true
                }
            },video);
            SVP.setMedia(mediaConfig);
            if(video.videoId !== "ifivideo" && this.sticky && typeof this.sticky.setStickyTitle == 'function') this.sticky.setStickyTitle(video.title);
            // Chapters to show/hide while switch b/w videos
            let chaptersCon =  document.querySelector('.svp-module .chapters-plugin-container');
            if (chaptersCon) video.videoId !== "ifivideo" ? chaptersCon.classList.remove('hide') :chaptersCon.classList.add('hide');
        }
    }
    handleLabelChange(nextState = this.state.getValue()) {
        const { playing, watched } = nextState;
        let { label } = this;
        if (playing) {
            label.classList.remove("watched");
            label.classList.add("playing");
            label.innerHTML = "Now Playing";
        } else if (watched) {
            label.classList.remove("playing");
            label.classList.add("watched");
            label.innerHTML = "Watched";
        } else {
            label.classList.remove("playing");
            label.innerHTML = "";
        }
    }
    init() {
        let { SVP, config } = this;
        let { video, playlist } = config;
        let aEl = this.el.querySelector('a');
        if (config.isPlaylist) {

        } else if (aEl != null) {
            aEl.addEventListener('click', e => {
                this.handleClick(e);
            })
        }
        let labelEl = this.el.querySelector('.label');

        if (playlist.jobCode && playlist.jobCode.trim() != "") {
            let jobCodeEl = document.createElement('div');
            jobCodeEl.classList.add("job-code");
            jobCodeEl.innerHTML = `<span>${playlist.jobCode}</span>`;
            this.el.querySelector('.meta-data').appendChild(jobCodeEl);
        }

        if (labelEl != null) {
            this.initLabel(labelEl);
            this.label = labelEl;
            let stateSource = this.state.subscribe(nextState => {
                this.handleLabelChange(nextState);
            })
            this.subscriptions.push(stateSource);
            this.handleLabelChange(this.state);
            if (!this.config.isIfi && this.config.video && this.config.video.autoplay) this.setState({ playing: true });
        }
        if(!config.isIfi) {
            try {
                let videoSaver = new VideoSaver(config);
                videoSaver.init();
                if(videoSaver.saveIcon !== null) {
                    aEl.insertAdjacentElement("afterend", videoSaver.saveIcon);
                }
            } catch(err) {
                console.log(err);
            }
        }
    }
    initLabel(labelEl) {
        let { SVP: player, config } = this;
        let { video } = config;

        if (player != null && player.amp.AmpEventsSources != null && this.subscriptions.length == 0) {
            let subscription4 = player.amp.AmpEventsSources["mediachange"].subscribe(eventData => {
                const flag = (video["videoId"] == eventData.videoId);
                if (this.state.playing != flag) {
                    this.setState({
                        playing: flag
                    })
                }

            })
            let subscription1 = player.amp.AmpEventsSources["playing"].subscribe(eventData => {
                const flag = (video["videoId"] == eventData.videoId);
                if (this.state.playing != flag) {
                    this.setState({
                        playing: flag
                    })
                }

            })
            let subscription2 = player.amp.AmpEventsSources["ended"].subscribe(eventData => {
                if (eventData.videoId == video["videoId"]) {
                    this.setState({
                        playing: false,
                        watched: true
                    })
                }
            })

            let subscription3 = player.amp.AmpEventsSources["destroy"].subscribe(eventData => {
                this.destroySubscriptions();
                if (this.state.playing) {
                    this.setState({
                        playing: false
                    })
                }
            })
            this.subscriptions.push(subscription1);
            this.subscriptions.push(subscription2);
            this.subscriptions.push(subscription3);
            this.subscriptions.push(subscription4);

        }
    }
    setState(newState = this.state) {
        let nextState = Object.assign({}, this.state.getValue(), newState);
        this.state.next(nextState);
    }
    get metaData() {
        let { config } = this;
        let { title, header, jobCode } = config.playlist;
        if (config.isIfi) {
            return `
                  <div class="meta-data">
                     <div class="header"><span>${header}</span></div>
                     <div class="playlist-title"><span>${title}</span></div>
                  </div>
            `
        } else {
            return `
                 <div class="meta-data">
                    <div class="playlist-title"><span>${title}</span></div>
                 </div>
            `;
        }
    }
    get el() {
        if (this._el == null) {
            let { config, metaData } = this;
            let { title } = config.playlist;
            let thumbnail = config.playlist.thumbnail ? config.playlist.thumbnail : ""; 
            let el = document.createElement('div');
            el.classList.add('recap-playlist-item');

            if (thumbnail.startsWith("en/")) {
                thumbnail = thumbnail.replace("en/", "");
            }
            
            if( !thumbnail.startsWith("http") && !thumbnail.startsWith("//")){
                thumbnail = `//${getImageServer()}/${thumbnail}`;
            }
            let defaultHref = "javascript:void(0)"
            let contentCx = "content-container";
            let label = `<div class="label"></div>`;
            if (config.isIfi) {
                contentCx += " ifi";
            }
            if(config.isPlaylist) {
                defaultHref = config.link ? config.link :"/viewarticle/945911";
                label = "";
            }
            let template = `
                   <a class="video-item" href="${defaultHref}">
                      <div class="${contentCx}">
                         <div class="flex-content">
                            <div class="image-container" style="background-image: url('${thumbnail}');">
                               ${label}
                               <div class="play-overlay">
                                  <div class="icon-container">
                                     <svg width="46" height="46" viewBox="0 0 46 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                           <g transform="translate(-489.000000, -116.000000)">
                                              <g transform="translate(490.000000, 117.000000)">
                                                 <ellipse stroke="#FFFFFF" fill-opacity="0.200000003" fill="#000000" cx="22.0507614" cy="22.1690722" rx="22.0507614" ry="22.1690722"></ellipse>
                                                 <polyline fill="#FFFFFF" points="19.2944162 29.6250245 19.2944162 14.437326 29.0119112 22.0305077 19.2944162 29.6250245"></polyline>
                                              </g>
                                           </g>
                                        </g>
                                     </svg>
                                  </div>
                               </div>
                            </div>
                         </div>
                         ${ metaData }
                      </div>
                   </a>
                `
            el.innerHTML = template;
            this._el = el;
        }
        return this._el
    }

}

export { PlaylistItem }